import { NgModule } from '@angular/core';
import { ModalComponent } from './modal.component';
import { CommonModule } from '@angular/common';
import { BoxModelModule, EventsModule } from '@circe/core';

@NgModule({
  declarations: [ModalComponent],
  imports: [
    CommonModule,
    EventsModule.forChild(),
    BoxModelModule.forChild()
  ],
  exports: [ModalComponent]
})
export class ModalModule {}
